import buzz from '@/static/assets/pet/cat/reviews/buzz.jpg';
import dot from '@/static/assets/pet/cat/reviews/dot.jpg';
import kilo from '@/static/assets/pet/cat/reviews/kilo.jpg';
import milo from '@/static/assets/pet/cat/reviews/milo.jpg';
import riley from '@/static/assets/pet/cat/reviews/riley.jpg';
import sailor from '@/static/assets/pet/cat/reviews/sailor.jpg';
import bentley from '@/static/assets/pet/dog/reviews/bentley.jpg';
import dublin from '@/static/assets/pet/dog/reviews/dublin.jpg';
import duchessofpork from '@/static/assets/pet/dog/reviews/duchessofpork.jpg';
import kona from '@/static/assets/pet/dog/reviews/kona.jpg';
import simba from '@/static/assets/pet/dog/reviews/simba.jpg';
import willoughby from '@/static/assets/pet/dog/reviews/willoughby.jpg';
import type { Story } from './StoryCard';

export const PET_STORIES: Story[] = [
  {
    name: 'Riley',
    description: '1-year-old Mixed Breed',
    injury: 'Broken Leg',
    img: riley.src,
    text: 'Riley fell and couldn’t get up. She was taken to the vet, where X-rays revealed a broken leg, and she had to undergo emergency surgery.',
    vetBill: '$5,391',
    savedWithLemonade: '$4,248',
  },
  {
    name: 'Dublin',
    description: '4-year-old Mixed Breed',
    injury: 'Cancer',
    img: dublin.src,
    text: 'Dublin collapsed twice and was having seizures. He was diagnosed with cancer and brain tumor, and is now getting treatments.',
    vetBill: '$15,259',
    savedWithLemonade: '$14,143',
  },
  {
    name: 'Sailor',
    description: '1-year-old Domestic Shorthair',
    injury: 'Gastroenteritis',
    img: sailor.src,
    text: 'Sailor started vomiting and was taken to the vet where they diagnosed Sailor with gastroenteritis. After being prescribed medication, she is back to her normal self.',
    vetBill: '$2,625',
    savedWithLemonade: '$1,791',
  },
  {
    name: 'Kona',
    description: '4-year-old Pitbull Mix',
    injury: 'Gastrointestinal Issues',
    img: kona.src,
    text: 'Kona was rushed to the ER for severe vomiting. The vet diagnosed her with Irritable Bowel Disease (IBD). Kona is now on medication and back to her normal self!',
    vetBill: '$5,134',
    savedWithLemonade: '$4,619',
  },
  {
    name: 'Milo',
    description: '11-month-old Domestic Longhair',
    injury: 'Foreign Material Ingestion',
    img: milo.src,
    text: 'Milo chewed the ties off a pair of pants, which caused him to vomit. The vet discovered a blockage in his intestine and he was taken to surgery for removal.',
    vetBill: '$1,589',
    savedWithLemonade: '$1,066',
  },
  {
    name: 'Willoughby',
    description: '1-year-old Mixed Breed',
    injury: 'Laceration/Severe Cut',
    img: willoughby.src,
    text: 'Willoughby was out for a walk when he severely cut his paw. He was taken to the vet to get stitches.',
    vetBill: '$896',
    savedWithLemonade: '$419',
  },
];

export const DOG_STORIES: Story[] = [
  {
    name: 'Simba',
    description: '8-year-old Labrador Retriever',
    injury: 'Blastomycosis',
    img: simba.src,
    text: 'Simba had to undergo surgery to remove a cyst under his throat, along with various tests and medications.',
    vetBill: '$2,898',
    savedWithLemonade: '$2,163',
  },
  {
    name: 'Kona',
    description: '4-year-old Pitbull Mix',
    injury: 'Gastrointestinal Issues',
    img: kona.src,
    text: 'Kona was rushed to the ER for severe vomiting. The vet diagnosed her with Irital Bowel Disease (IBD). Kona is now on medication and is back to her normal self!',
    vetBill: '$5,134',
    savedWithLemonade: '$4,619',
  },
  {
    name: 'Dublin',
    description: '4-years-old Mixed Breed',
    injury: 'Cancer',
    img: dublin.src,
    text: 'Dublin collapsed twice and was having seizures. He was diagnosed with cancer and a brain tumor, and is now getting treatments.',
    vetBill: '$15,259',
    savedWithLemonade: '$14,143',
  },
  {
    name: 'Duchess of Pork',
    description: '10-months-old	English Bulldog',
    injury: 'Aspiration Pneumonia',
    img: duchessofpork.src,
    text: 'Duchess of Pork was diagnosed with aspiration pneumonia and a mass on her lungs. She was hospitalized more than four times after surgery complications.',
    vetBill: '$21,804',
    savedWithLemonade: '$18,885',
  },
  {
    name: 'Willoughby',
    description: '1-year-old Mixed Breed',
    injury: 'Laceration/Severe Cut',
    img: willoughby.src,
    text: 'Willoughby was out for a walk when he severely cut his paw. He was taken to the vet to get stitches.',
    vetBill: '$896',
    savedWithLemonade: '$419',
  },
  {
    name: 'Bentley Romeo Dave Tipton',
    description: '1-year-old Bernedoodle',
    injury: 'Meningitis',
    img: bentley.src,
    text: 'Bently was diagnosed with Meningitis.',
    vetBill: '$3,044',
    savedWithLemonade: '$2,167',
  },
];

export const CAT_STORIES: Story[] = [
  {
    name: 'Dot',
    description: '2-year-old Domestic Shorthair',
    injury: 'Stranguria',
    img: dot.src,
    text: `Dot had diarrhea and frequent urination, and the vet diagnosed her with stranguria. She's doing much better after her medication.`,
    vetBill: '$632',
    savedWithLemonade: '$426',
  },
  {
    name: 'Sailor',
    description: '1-year-old Domestic Shorthair',
    injury: 'Gastroenteritis',
    img: sailor.src,
    text: 'Sailor started vomiting and was taken to the vet, where they diagnosed her with gastroenteritis. After being prescribed medication, she is back to her normal self.',
    vetBill: '$2,625',
    savedWithLemonade: '$1,791',
  },
  {
    name: 'Riley',
    description: '1-year-old Mixed Breed',
    injury: 'Broken Leg',
    img: riley.src,
    text: `Riley fell and couldn't get up. She was taken to the vet, where X-rays revealed a broken leg, and she had to undergo emergency surgery.`,
    vetBill: '$5,391',
    savedWithLemonade: '$4,248',
  },
  {
    name: 'Kilo',
    description: '	2-year-old Mixed Breed',
    injury: 'Upper Respiratory Infection',
    img: kilo.src,
    text: 'After dry heaving for a few days, Kilo was taken to the vet for various tests. He was diagnosed an upper respiratory infection and prescribed medication.',
    vetBill: '$1,544',
    savedWithLemonade: '$1,266',
  },
  {
    name: 'Milo',
    description: '11-month-old Domestic Longhair',
    injury: 'Foreign Material Ingestion',
    img: milo.src,
    text: 'Milo chewed the ties off of a pair of pants which caused him to vomit. The vet discovered a blockage in his intestine and he was taken to surgery for removal.',
    vetBill: '$1,589',
    savedWithLemonade: '$1,066',
  },
  {
    name: 'Buzz',
    description: '3-year-old Mixed Breed',
    injury: 'Heart Murmur',
    img: buzz.src,
    text: 'Buzz ate a leaf of a lily, which is toxic. He was taken to the vet and unexpectedly diagnosed with a heart murmur. Buzz ended up undergoing surgery.',
    vetBill: '$13,691',
    savedWithLemonade: '$12,522',
  },
];
